import React from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import NotFound from "../../../../CustomComponents/AllLoader/NotFound";

export default function AllFolder({
  folder,
  setfoldervalues,
  setdisplayAllFolders,
  setdisplayFileListings,
}) {
  const setvalues = (item) => {
    setfoldervalues(item);
    setdisplayAllFolders(false);
    setdisplayFileListings(true);
  };

  return (
    <div className="row grid-row">
      {Array.isArray(folder) && folder.length != 0 ? (
        <>
          {folder?.map((item, index) => (
            <div className="col-md-2 col-6">
              <div className="ic-folder" onClick={() => setvalues(item)}>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/ic_folder.png`}
                  className="w-100"
                  alt=""
                />
                <p>{item?.title}</p>
              </div>
            </div>
          ))}
        </>
      ) : (
        <NotFound title="No folders found" />
      )}
    </div>
  );
}
